import { render, staticRenderFns } from "./OrderUpload.vue?vue&type=template&id=0c20abf8&"
import script from "./OrderUpload.vue?vue&type=script&lang=js&"
export * from "./OrderUpload.vue?vue&type=script&lang=js&"
import style0 from "./OrderUpload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderUpload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports